import React from "react";
import ConferenceTable from "../../components/Investor/ConferenceTable.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const Conference = () => {
  return (
    <>
      <MetaComponent
        title="Conference call recordings | Aptech Ltd, a leading vocational training institute"
        desc="Get insights into Aptech’s performance, financials, and more from the conference call recordings."
        keywords="Aptech conference call recordings, Aptech shareholder pattern, investors reports, investor relations"
      />
      <ConferenceTable />
    </>
  );
};

export default Conference;
